import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BusinessContactDialogComponent } from 'src/app/components/page/business-contact-dialog/business-contact-dialog.component';

@Component({
  selector: 'app-business-page',
  templateUrl: './business-page.component.html',
  styleUrls: ['./business-page.component.scss'],
})
export class BusinessPageComponent {
  list: any = [
    {
      icon: '../../../../assets/images/business/part1.webp',
      text: '供应商入驻计划',
      link: '/cooperate',
    },
    {
      icon: '../../../../assets/images/business/part2.webp',
      text: '联盟营销合作',
      link: '/sales-introduction',
    },
    {
      icon: '../../../../assets/images/business/part3.webp',
      text: '企业批量采购',
    },
    {
      icon: '../../../../assets/images/business/part4.webp',
      text: '定制化合作提案',
    },
  ];

  constructor(
    private dialog: MatDialog,
  ) {
  }

  open(i: number) {
    if (i === 2 || i === 3) {
      this.dialog.open(BusinessContactDialogComponent, {
        panelClass: 'app-dialog',
        data: i,
        width: '680px',
        autoFocus: false,
      });
    }
  }
}
